import { render } from "./MaxlengthElement.vue?vue&type=template&id=2db7c63e"
import script from "./MaxlengthElement.vue?vue&type=script&lang=js"
export * from "./MaxlengthElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__